import request from '@/utils/request';

//获取租控概览
export function getRentalOverview(params) {
	return new Promise((resolve, reject) => {
		request({
			url: '/api/rental/overview',
			method: 'get',
			params,
		})
			.then(response => {
				const res = response.data;
				if (res.code == 0) {
					resolve(res.data);
				} else {
					reject(new Error(res.msg || '获取租控概览失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}

//查询最近6个月的出租统计数据
export function getRentalLast6months(params) {
	return new Promise((resolve, reject) => {
		request({
			url: '/api/rental/last6months',
			method: 'get',
			params,
		})
			.then(response => {
				const res = response.data;
				if (res.code == 0) {
					resolve(res.data);
				} else {
					reject(new Error(res.msg || '查询最近6个月的出租统计数据失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}

//获取合同期限分布
export function getRentalContractTerm(params) {
	return new Promise((resolve, reject) => {
		request({
			url: '/api/rental/contract-term-distribution',
			method: 'get',
			params,
		})
			.then(response => {
				const res = response.data;
				if (res.code == 0) {
					resolve(res.data);
				} else {
					reject(new Error(res.msg || '获取合同期限分布失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}

//获取合同到期分布
export function getRentalContractExpiry(params) {
	return new Promise((resolve, reject) => {
		request({
			url: '/api/rental/contract-expiry-distribution',
			method: 'get',
			params,
		})
			.then(response => {
				const res = response.data;
				if (res.code == 0) {
					resolve(res.data);
				} else {
					reject(new Error(res.msg || '获取合同到期分布失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}
